module.exports = __webpack_public_path__ + "static/media/detalle-webinar.9f70904e.jpg";